const esLang = {
  title: 'Sanfer Global',
  subtitle: 'Grupo Sanfer está constituido por las siguientes empresas: ',
  visit: 'Visitar sitio web',
}
const enLang = {
  title: 'Sanfer Global',
  subtitle: 'Sanfer is made up of the following companies: ',
  visit: 'Visitar sitio web',
}

export const langTexts = {
  es: esLang,
  en: enLang
} 